import { z } from 'zod';

export const ACTIVITY_TREND_RANGES = ['7d', '30d', '90d'] as const;

export const ActivityTrendRangeSchema = z.enum(ACTIVITY_TREND_RANGES);

export const ActivityTrendGranularitySchema = z.enum(['day', 'week']);

export const ActivityTrendQuerySchema = z.object({
  range: ActivityTrendRangeSchema.default('30d').describe(
    'Window ending now: 7d and 30d use daily buckets, 90d uses weekly buckets',
  ),
});

export const ActivityTrendBucketSchema = z.object({
  start: z.string().describe('UTC date (YYYY-MM-DD) the bucket starts on'),
  findings: z.number().int().nonnegative(),
  signals: z.number().int().nonnegative(),
  executions: z.number().int().nonnegative(),
});

export const ActivityTrendResponseSchema = z.object({
  range: ActivityTrendRangeSchema,
  granularity: ActivityTrendGranularitySchema,
  buckets: z.array(ActivityTrendBucketSchema),
});

export type ActivityTrendRange = z.infer<typeof ActivityTrendRangeSchema>;
export type ActivityTrendGranularity = z.infer<
  typeof ActivityTrendGranularitySchema
>;
export type ActivityTrendBucket = z.infer<typeof ActivityTrendBucketSchema>;
export type ActivityTrendResponse = z.infer<typeof ActivityTrendResponseSchema>;
